import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'cc-get-number-top-bar',
  templateUrl: './get-number-top-bar.component.html',
  styleUrls: ['./get-number-top-bar.component.scss']
})
export class GetNumberTopBarComponent implements OnInit {
  @Input() text: string;
  @Input() boldText: string;
  @Output() topBarClick = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  handleTopBarClicked() {
    this.topBarClick.emit();
  }
}
